import { setEditableFieldError } from '../store';
export var validate = function (params, validators) {
    var validationResults = validators.map(function (validator) { return validator({ store: params.store }); });
    var isValid = validationResults.every(function (result) { return result.isValid; });
    return { isValid: isValid, errors: validationResults.flatMap(function (result) { return result.errors; }) };
};
export var setErrorsFromValidationResults = function (params) {
    var results = Array.isArray(params.validationResults) ? params.validationResults : [params.validationResults];
    results.forEach(function (result) {
        result.errors.forEach(function (error) {
            params.store.dispatch(setEditableFieldError({ name: error.field, error: { message: error.message } }));
        });
    });
};
